const type = [
  { value: 1, label: 'Sales CRM' },
  { value: 2, label: 'Service CRM' },
  { value: 3, label: 'Realestate CRM' }
];
export default type;